var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelDetailCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 466,
    height: 161
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__m",
    x1: "111.629%",
    x2: "-16.319%",
    y1: "12.482%",
    y2: "116.326%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0EB4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__a",
    x1: "50%",
    x2: "49.252%",
    y1: "80.076%",
    y2: "39.687%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B6B9BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__c",
    x1: "50%",
    x2: "49.252%",
    y1: "50.978%",
    y2: "49.665%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B6B9BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#001674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__g",
    x1: "50%",
    x2: "50%",
    y1: "-104.839%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#001674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__i",
    x1: "111.938%",
    x2: "-16.652%",
    y1: "23.271%",
    y2: "97.253%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0EB4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__k",
    x1: "111.629%",
    x2: "-16.319%",
    y1: "12.482%",
    y2: "116.326%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0EB4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__l",
    x1: "111.629%",
    x2: "-16.319%",
    y1: "12.482%",
    y2: "116.326%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0EB4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__b",
    x1: "50%",
    x2: "49.252%",
    y1: "54.514%",
    y2: "48.452%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B6B9BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__n",
    x1: "50%",
    x2: "50%",
    y1: "-121.228%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#001674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__o",
    x1: "57.947%",
    x2: "41.448%",
    y1: "12.482%",
    y2: "116.326%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0EB4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__p",
    x1: "50%",
    x2: "50%",
    y1: "-104.839%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#008BD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#001674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__q",
    x1: "111.938%",
    x2: "-16.652%",
    y1: "49.262%",
    y2: "51.304%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0EB4FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-completed_svg__r",
    x1: "66.458%",
    x2: "32.29%",
    y1: "12.482%",
    y2: "116.326%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0EB4FA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hotel-detail-completed_svg__d",
    d: "M.138.518h130.118v11.259H.138z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hotel-detail-completed_svg__f",
    d: "M.138.518h130.118v11.259H.138z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hotel-detail-completed_svg__j",
    d: "M.599.172h42.559v35.922H.599z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__a)",
    d: "M224.944 159.236c2.523-21.405 15.272-32.108 38.247-32.108 34.463 0 37.293-30.343 60.467-42.301 23.173-11.96 31.788 7.892 57.003-9.966 25.215-17.857 43.8-33.152 70.92-19.186 18.08 9.31 17.814 43.773-.8 103.388l-225.837.173z",
    opacity: 0.3,
    transform: "translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__b)",
    d: "M152.332 25.5c5.982 0 11.128 3.576 13.418 8.707a7.923 7.923 0 0112.337 2.545 5.864 5.864 0 012.078-.378c2.92 0 5.34 2.131 5.791 4.923.737.665 1.593 1.41 2.566 2.236 3.413 2.897 15.4 4.421 35.96 4.573l-44.262-.001-.055.001h-.055l-9.102-.001-.062.001h-.062l-36.773-.001-.061.001H96c12.912-.381 23.393-1.566 31.443-3.552a7.92 7.92 0 0111.564-10.548c2.333-5.023 7.422-8.506 13.325-8.506z",
    transform: "translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__c)",
    d: "M129.662 125.408c59.522-2.046 117.24-11.812 201.974 9.512 56.49 14.215 100.792 22.375 132.905 24.48h-464c46.4-21.298 89.44-32.628 129.121-33.992z",
    transform: "matrix(-1 0 0 1 465.583 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeWidth: 0.924,
    d: "M195.895 92.373c13.569 7.58 26.805 8.767 39.708 3.561m-39.708-10.03c13.569 7.58 26.805 8.768 39.708 3.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeWidth: 0.749,
    d: "M295.85 44.189h-13.438v21.489h13.438v-21.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M227.906 28.841h122.44v118.463h-122.44z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#CCC",
    xlinkHref: "#hotel-detail-completed_svg__d",
    transform: "translate(223.929 27.328)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M229.168 131.054h38.684v16.25h-47.925v-7.01a9.24 9.24 0 019.24-9.24zm81.242 0h38.685a9.24 9.24 0 019.24 9.24v7.01h-47.923v-16.25zM272.332 21.142h33.599v18h-33.599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M268.43 19.674h41.403v5.181H268.43z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M193.922 79.814h3.559v65.61h-3.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M189.76 142.058h11.354v5.545H189.76z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeWidth: 0.924,
    d: "M188.035 91.167h14.474M190.801 84.9h10.139"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#002681",
    strokeWidth: 0.924,
    d: "M195.895 92.373c13.569 7.58 26.805 8.767 39.708 3.561m-39.708-10.03c13.569 7.58 26.805 8.768 39.708 3.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeWidth: 0.749,
    d: "M295.85 44.189h-13.438v21.489h13.438v-21.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__e)",
    d: "M8.586 9.83h122.44v118.463H8.586z",
    transform: "translate(219.32 19.011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001F7B",
    d: "M227.906 28.841h122.44v12.671h-122.44z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.929 27.328)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hotel-detail-completed_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hotel-detail-completed_svg__f"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hotel-detail-completed_svg__g)",
    xlinkHref: "#hotel-detail-completed_svg__f"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#0186CE",
    strokeWidth: 2.218,
    mask: "url(#hotel-detail-completed_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.669 3.316H147.05"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0186CE",
    strokeWidth: 2.218,
    mask: "url(#hotel-detail-completed_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.669 7.937H147.05"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hotel-detail-completed_svg__i)",
    xlinkHref: "#hotel-detail-completed_svg__j",
    transform: "translate(267.253 111.211)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001F7B",
    d: "M267.852 111.382h42.559v7.121h-42.559z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.414 120.473)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.429,
    cy: 10.153,
    fill: "url(#hotel-detail-completed_svg__k)",
    rx: 9.126,
    ry: 9.149
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.471,
    cy: 10.821,
    fill: "url(#hotel-detail-completed_svg__l)",
    rx: 7.916,
    ry: 7.936
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.555,
    cy: 11.077,
    fill: "url(#hotel-detail-completed_svg__m)",
    rx: 5.817,
    ry: 5.832
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.468,
    cy: 12.925,
    fill: "url(#hotel-detail-completed_svg__k)",
    rx: 9.126,
    ry: 9.149
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.51,
    cy: 8.048,
    fill: "url(#hotel-detail-completed_svg__l)",
    rx: 7.916,
    ry: 7.936
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.594,
    cy: 11.077,
    fill: "url(#hotel-detail-completed_svg__m)",
    rx: 5.817,
    ry: 5.832
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__n)",
    d: "M9.848 112.043h38.684v16.25H.607v-7.01a9.24 9.24 0 019.24-9.24zm81.242 0h38.685a9.24 9.24 0 019.24 9.24v7.01H91.092v-16.25z",
    transform: "translate(219.32 19.011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001F7B",
    d: "M271.17 41.33h1.844v68.383h-1.844zm34.106 0h1.844v68.383h-1.844z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__o)",
    d: "M53.012 2.131h33.599v93.801H53.012z",
    transform: "translate(219.32 19.011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__p)",
    d: "M49.11.663h41.403v5.181H49.11z",
    transform: "translate(219.32 19.011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001F7B",
    d: "M277.623 107.865h22.123v1.848h-22.123z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__q)",
    d: "M44.415 90.382h50.782v7.121H44.415z",
    transform: "translate(219.32 19.011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M277.576 125.922h23.857v21.382h-23.857z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#002580",
    strokeWidth: 0.749,
    d: "M289.076 125.922v21.382"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#002681",
    d: "M193.922 79.814h3.559v65.61h-3.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002681",
    d: "M189.76 142.058h11.354v5.545H189.76z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#002681",
    strokeWidth: 0.924,
    d: "M188.035 91.167h14.474M190.801 84.9h10.139"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M243.704 54.979h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M244.866 54.979h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__r)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    transform: "translate(241.011 53.096)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BD5F1",
    d: "M244.866 54.979h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M241.992 54.409h15.269v1.422h-15.269z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M241.992 54.409h15.269v1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M241.011 53.096h17.231v1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M241.011 53.096h17.231v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M241.992 73.403h15.269v-1.422h-15.269z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M241.992 73.403h15.269v-1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M241.011 74.716h17.231v-1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M241.011 74.716h17.231v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M322.862 54.979h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M324.024 54.979h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__r)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    transform: "translate(320.169 53.096)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BD5F1",
    d: "M324.024 54.979h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M321.15 54.409h15.269v1.422H321.15z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M321.15 54.409h15.269v1H321.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M320.169 53.096H337.4v1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M320.169 53.096H337.4v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M321.15 73.403h15.269v-1.422H321.15z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M321.15 73.403h15.269v-1H321.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M320.169 74.716H337.4v-1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M320.169 74.716H337.4v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M243.704 84.736h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M244.866 84.736h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__r)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    transform: "translate(241.011 82.853)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BD5F1",
    d: "M244.866 84.736h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M241.992 84.166h15.269v1.422h-15.269z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M241.992 84.166h15.269v1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M241.011 82.853h17.231v1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M241.011 82.853h17.231v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M241.992 103.16h15.269v-1.422h-15.269z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M241.992 103.16h15.269v-1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M241.011 104.473h17.231v-1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M241.011 104.473h17.231v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M322.862 84.736h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M324.024 84.736h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-completed_svg__r)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    transform: "translate(320.169 82.853)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9BD5F1",
    d: "M324.024 84.736h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M321.15 84.166h15.269v1.422H321.15z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M321.15 84.166h15.269v1H321.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M320.169 82.853H337.4v1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M320.169 82.853H337.4v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M321.15 103.16h15.269v-1.422H321.15z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M321.15 103.16h15.269v-1H321.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09A3EA",
    d: "M320.169 104.473H337.4v-1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M320.169 104.473H337.4v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0069B7",
    d: "M283.153 37.496h11.946v17.315h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M283.153 37.496h11.946v8.658h-11.946z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M282.188 37.496h13.875v1.332h-13.875zm0 16.649h13.876v1.332h-13.876z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0069B7",
    d: "M283.153 70.429h11.946v17.315h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M283.153 70.429h11.946v8.658h-11.946z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3F7B",
    d: "M282.188 70.429h13.875v1.332h-13.875zm0 16.649h13.876v1.332h-13.876z"
  }))))));
}
export default SvgHotelDetailCompleted;